"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import ComparisonComponent from "./components/comparison";
import FeaturesComponent from "./components/features";
import UseCasesComp from "./components/useCases";

const EmulateSimulateRealPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PocCloudTabs />
        <Intro />
        <FeaturesComponent />
        <ComparisonComponent />
        <UseCasesComp />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default EmulateSimulateRealPage;
